const CAInfo = ({ comp_analysis }) => {
    return (
        <>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Table Properties (Chart Data Export Only)</h3>
            </div>

            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Style</h4>
                    <h3>{comp_analysis?.table?.table_style || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Column Width (Only for excel export)</h4>
                    <h3>{`${comp_analysis?.table?.col_width} inch` || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Table Page Fit</h4>
                    <h3>{comp_analysis?.table?.table_page_fit === true ? "True" : "False"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Font Name</h4>
                    <h3>{comp_analysis?.table?.custom_head?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Font Size</h4>
                    <h3>{comp_analysis?.table?.custom_head?.font_size ? `${comp_analysis?.table?.custom_head?.font_size} pt` : "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Font Color</h4>
                    <h3>
                        {comp_analysis?.table?.custom_head?.bg_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: comp_analysis?.table?.custom_head?.bg_color
                                    ? `#${comp_analysis?.table?.custom_head?.font_color}`
                                    : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Background Color</h4>
                    <h3>
                        {comp_analysis?.table?.custom_head?.bg_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: comp_analysis?.table?.custom_head?.bg_color ? `#${comp_analysis?.table?.custom_head?.bg_color}` : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Alignment</h4>
                    <h3>{comp_analysis?.table?.custom_head?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Custom Heading Cell Margin Top</h4>
                    <h3>{comp_analysis?.table?.custom_head?.cell_margin?.top || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Cell Margin Left</h4>
                    <h3>{comp_analysis?.table?.custom_head?.cell_margin?.left || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Cell Margin Right</h4>
                    <h3>{comp_analysis?.table?.custom_head?.cell_margin?.right || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Cell Margin Bottom</h4>
                    <h3>{comp_analysis?.table?.custom_head?.cell_margin?.bottom || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Custom Heading Blank Line Height</h4>
                    <h3>
                        {comp_analysis?.table?.custom_head?.blank_line_height ? `${comp_analysis?.table?.custom_head?.blank_line_height} pt` : "-"}
                    </h3>
                </div>
            </div>
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Item Label</h4>
                    <h3>{comp_analysis?.table?.heading?.head_first_index_label || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Name</h4>
                    <h3>{comp_analysis?.table?.heading?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Font Size</h4>
                    <h3>{comp_analysis?.table?.heading?.font_size || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Heading Font Color</h4>
                    <h3>
                        {comp_analysis?.table?.heading?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: comp_analysis?.table?.heading?.font_color ? `#${comp_analysis?.table?.heading?.font_color}` : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Background Color</h4>
                    <h3>
                        {comp_analysis?.table?.heading?.bg_color || "-"}
                        <span
                            className="color"
                            style={{ backgroundColor: comp_analysis?.table?.heading?.bg_color ? `#${comp_analysis?.table?.heading?.bg_color}` : "" }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Heading Alignment</h4>
                    <h3>{comp_analysis?.table?.heading?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Heading Cell Margin Top</h4>
                    <h3>{comp_analysis?.table?.heading?.cell_margin?.top || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Cell Margin Left</h4>
                    <h3>{comp_analysis?.table?.heading?.cell_margin?.left || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Cell Margin Right</h4>
                    <h3>{comp_analysis?.table?.heading?.cell_margin?.right || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Heading Cell Margin Bottom</h4>
                    <h3>{comp_analysis?.table?.heading?.cell_margin?.bottom || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Data Font Name</h4>
                    <h3>{comp_analysis?.table?.data?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Data Font Size</h4>
                    <h3>{comp_analysis?.table?.data?.font_size || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Data Font Color</h4>
                    <h3>
                        {comp_analysis?.table?.data?.font_color || "-"}
                        <span
                            className="color"
                            style={{ backgroundColor: comp_analysis?.table?.data?.font_color ? `#${comp_analysis?.table?.data?.font_color}` : "" }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Data Alignment</h4>
                    <h3>{comp_analysis?.table?.data?.alignment || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Data Cell Margin Top</h4>
                    <h3>{comp_analysis?.table?.data?.cell_margin?.top || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Data Cell Margin Left</h4>
                    <h3>{comp_analysis?.table?.data?.cell_margin?.left || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Data Cell Margin Right</h4>
                    <h3>{comp_analysis?.table?.data?.cell_margin?.right || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Data Cell Margin Bottom</h4>
                    <h3>{comp_analysis?.table?.data?.cell_margin?.bottom || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Data Blank Line Height</h4>
                    <h3>{comp_analysis?.table?.data?.blank_line_height ? `${comp_analysis?.table?.data?.blank_line_height} pt` : "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Font Name</h4>
                    <h3>{comp_analysis?.table?.sub_total?.font_family || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub TotalFont Size</h4>
                    <h3>{comp_analysis?.table?.sub_total?.font_size || "-"}</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Font Color</h4>
                    <h3>
                        {comp_analysis?.table?.sub_total?.font_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: comp_analysis?.table?.sub_total?.font_color ? `#${comp_analysis?.table?.sub_total?.font_color}` : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Background Color</h4>
                    <h3>
                        {comp_analysis?.table?.sub_total?.bg_color || "-"}
                        <span
                            className="color"
                            style={{
                                backgroundColor: comp_analysis?.table?.sub_total?.bg_color ? `#${comp_analysis?.table?.sub_total?.bg_color}` : ""
                            }}
                        ></span>
                    </h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Sub Total Alignment</h4>
                    <h3>{comp_analysis?.table?.sub_total?.alignment || "-"}</h3>
                </div>
            </div>

            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4> Sub Total Cell Margin Top</h4>
                    <h3>{comp_analysis?.table?.sub_total?.cell_margin?.top || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Cell Margin Left</h4>
                    <h3>{comp_analysis?.table?.sub_total?.cell_margin?.left || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Cell Margin Right</h4>
                    <h3>{comp_analysis?.table?.sub_total?.cell_margin?.right || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-3 basic-box">
                <div className="codeOtr">
                    <h4>Sub Total Cell Margin Bottom</h4>
                    <h3>{comp_analysis?.table?.sub_total?.cell_margin?.bottom || "-"} inch</h3>
                </div>
            </div>
            <div className="col-md-6 basic-box"></div>
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Table Column Configuration-Recommendation</h3>
            </div>
            {comp_analysis?.ca_recommendation &&
                Object.entries(
                    typeof comp_analysis?.ca_recommendation === "string"
                        ? JSON.parse(comp_analysis?.ca_recommendation)
                        : comp_analysis?.ca_recommendation
                )?.map(([columnKey, columnData], index) => (
                    <div className="col-md-3 basic-box">
                        <div className="codeOtr">
                            <h4>{columnData?.label || "-"}</h4>
                            <h3>{columnData?.width || "-"} inch</h3>
                        </div>
                    </div>
                ))}
            <div className="col-md-12 basic-box main-heading mt-2">
                <h3>Table Column Configuration-Asset</h3>
            </div>
            {comp_analysis?.ca_asset &&
                Object.entries(typeof comp_analysis?.ca_asset === "string" ? JSON.parse(comp_analysis?.ca_asset) : comp_analysis?.ca_asset)?.map(
                    ([columnKey, columnData], index) => (
                        <div className="col-md-3 basic-box">
                            <div className="codeOtr">
                                <h4>{columnData?.label || "-"}</h4>
                                <h3>{columnData?.width || "-"} inch</h3>
                            </div>
                        </div>
                    )
                )}
        </>
    );
};

export default CAInfo;
